import React, { FC, ReactNode } from 'react'

import styles from './PlanSectionTitle.module.css'

type Variant = 'menu' | 'fitness'

type Props = {
  title: string
  variant: Variant
  action?: ReactNode
}

const { titleRow, titleMenu, titleFitness, showAction } = styles

const titleClassByVariant: Record<Variant, string> = {
  menu: titleMenu,
  fitness: titleFitness
}

const PlanSectionTitle: FC<Props> = ({ title, variant, action }) => {
  return (
    <div className={titleRow}>
      <h3 className={titleClassByVariant[variant]}>{title}</h3>
      {action != null && <div className={showAction}>{action}</div>}
    </div>
  )
}

export default PlanSectionTitle
